<template>
  <!-- Generator: Adobe Illustrator 25.3.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
  <svg
    id="Ebene_1"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    enable-background="new 0 0 20 20"
    xml:space="preserve"
  >
    <path
      fill="currentColor"
      d="M12.888,20.057c-0.29,0-0.562-0.142-0.727-0.38l-4.39-6.324C6.003,13.82,3.494,11.93,1.669,8.77
	C0.782,7.232,0.202,5.625,0.035,4.243C-0.162,2.604,0.247,1.402,1.186,0.86c0.344-0.2,0.736-0.294,1.166-0.282
	c0.946-0.198,2.406-0.442,4.087-0.504c3.828-0.132,6.996,0.742,9.168,2.552c3.68,3.066,4.555,3.795,4.352,4.869
	c-0.164,0.869-1.014,1.153-2.19,1.546c-0.773,0.257-1.652,0.431-2.583,0.614c-2.071,0.41-4.413,0.874-5.96,2.35
	c-0.028,0.073-0.06,0.142-0.093,0.209l4.481,6.455c0.277,0.403,0.176,0.954-0.223,1.231C13.243,20.004,13.069,20.057,12.888,20.057z
	 M1.973,2.482C1.816,2.69,1.69,3.189,1.791,4.032c0.139,1.15,0.639,2.519,1.41,3.854c1.291,2.236,2.796,3.483,3.715,3.729
	c0.21,0.056,0.379,0.054,0.478-0.002l0.001-0.001c0.222-0.127,0.394-0.684,0.279-1.64c-0.139-1.15-0.639-2.519-1.41-3.854
	C4.962,3.865,3.385,2.544,2.455,2.369C2.246,2.414,2.083,2.454,1.973,2.482z"
    />
    <path
      fill="currentColor"
      d="M2.772,1.465c0.013,0.003,0.026,0.007,0.039,0.01L2.789,1.461C2.783,1.462,2.778,1.463,2.772,1.465z"
    />
  </svg>
</template>
